import {
    ableProps,
    ablePropsInit,
    exampleProps,
    examplePropsInit,
    requiredProps,
    requiredPropsInit,
    validatorProps,
    validatorPropsInit,
    events as baseEvents,
} from '../component-base/props';

export const props = () => [
    // {
    //     key: 'type',
    //     label: '选择器类型',
    //     type: 'enum',
    //     collection: [
    //         {
    //             label: '默认',
    //             value: 'default',
    //         },
    //         {
    //             label: '银行',
    //             value: 'bank',
    //         },
    //         {
    //             label: '银行支行',
    //             value: 'branch',
    //         },
    //     ],
    // },
    ...ableProps,
    {
        key: 'placeholder',
        label: '占位文字',
        type: 'string',
    },
    {
        key: 'headerText',
        label: '选择器标题文字',
        type: 'string',
    },
    {
        key: 'cancelText',
        label: '取消文案（端外）',
        type: 'string',
    },
    {
        key: 'okText',
        label: '确认文案（端外）',
        type: 'string',
    },
    ...requiredProps,
    ...validatorProps,
    {
        key: 'group',
        label: '是否级联',
        type: 'boolean',
    },
    {
        key: 'column',
        label: '列数',
        type: 'number',
        props: {
            controls: false,
        },
    },
    {
        key: 'options',
        label: '所有选项',
        type: 'picker-array',
    },
    ...exampleProps,
    {
        key: 'pickerSettings',
        label: '选择类型配置',
        type: 'pickerSettings',
        props: {},
    },
    {
        key: 'ocrConfig',
        label: 'ocr内容配置',
        type: 'ocrConfig',
        props: {},
    },
];

export const init = () => ({
    ...examplePropsInit,
    pickerSettings: '',
    ...ablePropsInit,
    placeholder: '请选择',
    headerText: '',
    cancelText: '',
    okText: '',
    ...requiredPropsInit,
    ...validatorPropsInit,
    group: false,
    type: 'default',
    column: 1,
    options: [
        // 由于column的存在，options的数据结构是数组嵌套数组
        [
            {
                text: '选项一（value只支持字符串）',
                value: '1',
            },
            {
                text: '选项二（输出结果是对象）',
                value: '2',
            },
        ],
    ],
});

export const name = '选择器';

export const component = 'mobile-general-form-picker';

export const events = [
    'no-ks-bridge',
    'user-input',
    'change',
    ...baseEvents,
];

